import { Culture } from '../../types';

export const dene: Culture = {
  name: 'Dene',
  languageFamily: 'Athabaskan',
  terms: [
    {
      word: 'Edlánet’e',
      phonetic: 'ed-lah-neh-teh',
      description: 'Dene greeting meaning "hello."'
    },
    {
      word: 'Sųłįį',
      phonetic: 'soo-lee',
      description: 'Dene term for "good."'
    },
    {
      word: 'Tth’í',
      phonetic: 'tuh-thee',
      description: 'Word for "dog" in Dene.'
    },
    {
      word: 'Tsán',
      phonetic: 'tsahn',
      description: 'Dene word for "rock."'
    },
    {
      word: 'Yáá',
      phonetic: 'yah',
      description: 'Dene word for "snow."'
    }
  ]
};